<form [formGroup]="form" (ngSubmit)="save()" class="p-3">
  <div class="d-flex mt-3" style="gap: 20px; align-items: flex-start">
    <div class="flex-fill" style="max-width: 50%">
      <h2 class="mb-2">{{ "emailTemplate" | transloco }}</h2>

      <div class="form-group form-floating mb-2">
        <textarea
          class="inpt mb-3 email-template"
          formControlName="emailTemplate"
          autocomplete="off"
          type="text"
          placeholder="{{ 'text' | transloco }}"
        ></textarea>

        <div class="inpt-title">
          {{ "Content" | transloco }}
        </div>

        <p-editor
          [placeholder]="'footerText'"
          [style]="{ minHeight: '150px' }"
          formControlName="footerText"
        >
          <ng-template pTemplate="header">
            <app-editor
              [allowImageInsert]="true"
              [allowToolboxInsert]="true"
              [allowOnboardingInsert]="true"
              [allowSprintInsert]="true"
              [isEmail]="true"
            ></app-editor>
          </ng-template>
        </p-editor>

        <div class="inpt-title me-3">
          {{ "backgroundColor" | transloco }}
        </div>
        <div class="d-flex align-items-center">
          <p-colorpicker formControlName="backgroundColor"></p-colorpicker>
          <input
            type="text"
            formControlName="backgroundColor"
            class="form-control ms-2"
            [value]="form?.value.backgroundColor"
          />
        </div>

        <div class="d-flex gap-2 mt-3">
          <button type="submit" class="btn btn-large btn-orange flex-fill">
            <span>{{ "save" | transloco }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="flex-fill" style="margin-top: 40px">
      <div class="preview" [innerHTML]="previewHtml"></div>
    </div>
  </div>
</form>
